module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "main_car_dashboard"
    }
  }, [_c('fullscreen', {
    ref: "fullscreen",
    attrs: {
      "fullscreen": _vm.fullscreen
    },
    on: {
      "change": _vm.fullscreenChange,
      "update:fullscreen": function($event) {
        _vm.fullscreen = $event
      }
    }
  }, [(_vm.firstTimeNotification) ? _c('div', {
    attrs: {
      "id": "first-load-container"
    }
  }, [_c('div', {
    attrs: {
      "id": "first-load-content"
    }
  }, [_c('img', {
    attrs: {
      "id": "first-time-image",
      "src": "/static/img/About-Dashboard-image.png",
      "alt": "First time load",
      "srcset": ""
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "first-time-load-info"
    }
  }, [_c('h3', [_vm._v("Initializing...")]), _vm._v(" "), _c('p', [_vm._v("\n            Getting the platform ready for the first time takes longer, so you\n            can have seamless offline access to it later.\n          ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isChartRendered),
      expression: "!isChartRendered"
    }],
    attrs: {
      "id": "loading-screen"
    }
  }, [_c('div', {
    staticClass: "fancy-loader"
  }, [_c('span', [_vm._v("LOADING")]), _vm._v(" "), _c('svg', {
    staticClass: "lds-comets",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "200px",
      "height": "200px",
      "viewBox": "0 0 100 100",
      "preserveAspectRatio": "xMidYMid"
    }
  }, [_c('g', {
    attrs: {
      "transform": "rotate(162.228 50 50)"
    }
  }, [_c('animateTransform', {
    attrs: {
      "attributeName": "transform",
      "type": "rotate",
      "repeatCount": "indefinite",
      "values": "360 50 50;240 50 50;120 50 50;0 50 50",
      "keyTimes": "0;0.333;0.667;1",
      "dur": "1s",
      "keySplines": "0.7 0 0.3 1;0.7 0 0.3 1;0.7 0 0.3 1",
      "calcMode": "spline"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#41918E",
      "d": "M91,74.1C75.6,98,40.7,102.4,21.2,81c11,9.9,26.8,13.5,40.8,8.7c7.4-2.5,13.9-7.2,18.7-13.3 c1.8-2.3,3.5-7.6,6.7-8C90.5,67.9,92.7,71.5,91,74.1z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#E0E0E0",
      "d": "M50.7,5c-4,0.2-4.9,5.9-1.1,7.3c1.8,0.6,4.1,0.1,5.9,0.3c2.1,0.1,4.3,0.5,6.4,0.9c5.8,1.4,11.3,4,16,7.8 C89.8,31.1,95.2,47,92,62c4.2-13.1,1.6-27.5-6.4-38.7c-3.4-4.7-7.8-8.7-12.7-11.7C66.6,7.8,58.2,4.6,50.7,5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#80CBC4",
      "d": "M30.9,13.4C12,22.7,2.1,44.2,7.6,64.8c0.8,3.2,3.8,14.9,9.3,10.5c2.4-2,1.1-4.4-0.2-6.6 c-1.7-3-3.1-6.2-4-9.5C10.6,51,11.1,41.9,14.4,34c4.7-11.5,14.1-19.7,25.8-23.8C37,11,33.9,11.9,30.9,13.4z"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isDataLoadedFirstTime),
      expression: "!isDataLoadedFirstTime"
    }],
    staticClass: "text-xs-center",
    staticStyle: {
      "margin-top": "13em"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": 70,
      "width": 7,
      "color": "purple"
    }
  })], 1), _vm._v(" "), _c('div', {
    ref: "nav_cpanel",
    staticClass: "top_navigation_cpanel row",
    attrs: {
      "id": "nav_cpanel"
    }
  }, [_c('div', {
    staticClass: "col-xs-12",
    attrs: {
      "id": "car_top_selector_container"
    }
  }, [_c('div', {
    staticClass: "hidden",
    attrs: {
      "id": "top_of_page"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-5"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-10 title_placement",
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_c('h4', [_vm._v("ANALYSIS OF KEY HEALTH INDICATORS")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-7 top-navbar"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-8 compare-multiselect"
  }, [_c('label', {
    staticClass: "hidden"
  }, [_vm._v(_vm._s(_vm.multiselectPlaceholderComputed))]), _vm._v(" "), _c('span', {}, [_c('multi-select', {
    attrs: {
      "data-step": "2",
      "data-intro": "<b>Select Indicator</b><p>You can select a health indicator by clicking on this drop-down menu</p>",
      "options": _vm.optionIndicators,
      "group-values": "indicators",
      "group-label": "programArea",
      "group-select": false,
      "show-labels": true,
      "group-collapsible": _vm.collapsible,
      "group-collapsible-expanded": false,
      "allow-empty": false,
      "placeholder": _vm.multiselectPlaceholder,
      "track-by": "name",
      "label": "name"
    },
    on: {
      "close": function($event) {
        _vm.closedMultiselect(_vm.selectedIndicator.name)
      },
      "open": _vm.openedMultiselect,
      "search-change": _vm.multiselectSearch
    },
    model: {
      value: (_vm.selectedIndicator),
      callback: function($$v) {
        _vm.selectedIndicator = $$v
      },
      expression: "selectedIndicator"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Oops! No elements found. Change the search query.")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-3 year-multiselect compare-multiselect"
  }, [_c('multi-select', {
    attrs: {
      "data-step": "3",
      "data-position": "left",
      "data-intro": "<b>Select Location </b><p>Click here to select your desired location from the drop-down menu</p>",
      "options": _vm.optionStates,
      "hide-selected": false,
      "searchable": true,
      "allow-empty": false,
      "show-labels": false,
      "placeholder": _vm.statePlaceholder
    },
    on: {
      "close": function($event) {
        _vm.closedStateMultiselect(_vm.selectedState)
      },
      "open": _vm.openedStateMultiselect
    },
    model: {
      value: (_vm.selectedState),
      callback: function($$v) {
        _vm.selectedState = $$v
      },
      expression: "selectedState"
    }
  })], 1)])]), _vm._v(" "), _c('keep-alive', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "visible-xs-block"
  }, [_c('v-alert', {
    attrs: {
      "dismissible": "",
      "color": "warning",
      "outline": ""
    },
    model: {
      value: (_vm.alertMobile),
      callback: function($$v) {
        _vm.alertMobile = $$v
      },
      expression: "alertMobile"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-icon', [_vm._v("phone_iphone")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "5px"
    }
  }, [_c('b', [_vm._v("Mobile device detected")]), _c('br'), _c('br'), _vm._v("For the best experience,\n            please use this platform on your laptop/desktop.\n          ")])], 1)])], 1), _vm._v(" "), (_vm.detect) ? _c('div', {
    staticClass: "col-lg-4 col-md-7 col-sm-6 col-xs-12",
    attrs: {
      "id": "browserSupport"
    }
  }, [_c('button', {
    staticClass: "close mt-2",
    staticStyle: {
      "font-size": "20px"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "#browserSupport"
    },
    on: {
      "click": function($event) {
        _vm.closeAlert()
      }
    }
  }, [_c('span', {
    staticClass: "mb-4 mt-4 pt-4 pr-4",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "mt-4 pl-2"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/browser.png"
    }
  }), _c('strong', {
    staticClass: "alertBold"
  }, [_vm._v("Unsupported Browser!\n        ")])]), _vm._v(" "), _c('p', {
    staticClass: "p-4 pl-2"
  }, [_vm._v("\n        Looks like you are using a browser that is not supported, so you may\n        experience some problems.\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "pb-4 pl-2"
  }, [_vm._v("\n        Please use "), _c('strong', {
    staticClass: "alertBold"
  }, [_vm._v("Google Chrome")]), _vm._v(" browser\n        for the best experience with "), _c('br'), _vm._v("\n        MSDAT Platform.\n      ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDataLoadedFirstTime),
      expression: "isDataLoadedFirstTime"
    }],
    staticClass: "row",
    attrs: {
      "id": "firstRow"
    }
  }, [_c('div', {
    class: {
      'col-xs-12 col-md-11': _vm.barChartHidden,
      'col-sm-12 col-md-8': !_vm.barChartHidden,
    },
    attrs: {
      "id": "firstRow_sec1a"
    }
  }, [_c('table-component', {
    attrs: {
      "selectedIndicator56": _vm.selectedIndicator.name,
      "uncertaintyData": _vm.estimatesData,
      "meta_data": _vm.metaData,
      "indicatorMetaData": _vm.indicatorMetaData,
      "sourceMetaData": _vm.sourceMetaData,
      "appData": _vm.lsData
    },
    on: {
      "dataSourceForChart": _vm.chartSourceData,
      "toggleClicked": _vm.toggleClicked,
      "IHMEtoggleClicked": _vm.IHMEtoggleClicked,
      "indicatorRelatives": _vm.indicatorRelatives,
      "plotUncertainty": _vm.plotUncertainty
    }
  }), _vm._v(" "), _c('line-chart', {
    attrs: {
      "uncertaintyData": _vm.estimatesData,
      "appData": _vm.lsData,
      "isToggleClickedVal": _vm.isToggleClicked,
      "isIHMEtoggleClickedVal": _vm.isIHMEtoggleClicked,
      "meta_data": _vm.metaData
    },
    on: {
      "chartRendered": _vm.chartRendered,
      "compareIndicators": _vm.compareIndicators
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hidden"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  })])], 1), _vm._v(" "), _c('div', {
    class: {
      'col-sm-12 col-md-4': !_vm.barChartHidden,
      'col-sm-1 col-md-1': _vm.barChartHidden,
    },
    staticStyle: {
      "box-sizing": "border-box"
    },
    attrs: {
      "id": "firstRow_sec1b"
    }
  }, [_c('bar-chart-component', {
    attrs: {
      "appData": _vm.lsData,
      "metaData": _vm.metaData,
      "stateClicked": _vm.selectedState,
      "sourceOptions": _vm.zonalSourcesOptions,
      "lgaData": _vm.lgaData,
      "dashboardStateOptions": _vm.dashboardStateOptionsArray
    },
    on: {
      "optionYear": _vm.regionalChartYearOptions,
      "selectedYear": _vm.changeDashboardState,
      "plotData": _vm.getMapPlotData,
      "callerName": _vm.getCallerComponent,
      "barChartBoolValue": _vm.hideBarChartClicked
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "html2pdf__page-break"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative",
      "top": "-60px"
    },
    attrs: {
      "id": "zonalChart"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row text-center web-features zonal-section"
  }, [_c('div', {
    attrs: {
      "id": "zonal-title"
    }
  }, [_c('h5', [_vm._v("ZONAL SECTION")])]), _vm._v(" "), _c('div', {
    staticClass: "zonal-hide-button"
  }, [_c('button', {
    staticClass: "material-button-raised pull-left",
    staticStyle: {
      "box-shadow": "0 0 5px gray",
      "color": "black",
      "border-radius": "0",
      "margin-right": "30px"
    },
    on: {
      "click": function($event) {
        _vm.showMore('zonal')
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "11px",
      "font-family": "'Open Sans'"
    }
  }, [_vm._v("Click to " + _vm._s(_vm.showMoreMsg))])])])]), _vm._v(" "), _c('div', {
    staticClass: "line-breaker"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMoreFeatures),
      expression: "showMoreFeatures"
    }],
    staticClass: "row web-features"
  }, [_c('div', {
    attrs: {
      "data-v-step": "7"
    }
  }, [_c('regions-chart', {
    attrs: {
      "appData": _vm.lsData,
      "lgaData": _vm.lgaData,
      "yearOptions": _vm.regionalChartYearOptionsData,
      "selectedIndicator": _vm.selectedIndicator,
      "meta_data": _vm.metaData,
      "dashboardStateOptions": _vm.dashboardStateOptionsArray,
      "sources": _vm.optionSources
    },
    on: {
      "regionsChartYear": _vm.changeDashboardState,
      "callerName": _vm.getCallerComponent
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "compare-section-container row web-features",
    class: {
      'compare-dataset-heading': _vm.compareSectionColorClass
    },
    attrs: {
      "id": "compare-section"
    }
  }, [_c('div', {
    staticClass: "compare-heading col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-8",
    staticStyle: {
      "padding-left": "30px"
    }
  }, [_c('span', {}, [_c('label', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm.isElementToCompareIndicator ?
    " Multi-Dataset Comparison Section" :
    "Multi-Source Indicator Comparison Section"))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-2"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showComponents),
      expression: "showComponents"
    }],
    staticClass: "col-md-12"
  }, [_c('multi-select', {
    staticStyle: {
      "transform": "scale(0.9)"
    },
    attrs: {
      "options": _vm.optionStates,
      "hide-selected": false,
      "searchable": true,
      "allow-empty": false,
      "show-labels": false,
      "placeholder": _vm.comparisonSelectedStatePlaceholder
    },
    on: {
      "open": function($event) {
        _vm.openedCompareStateMultiselect()
      },
      "close": function($event) {
        _vm.closedCompareStateMultiselect(_vm.$store.state.CAR.selectedState)
      }
    },
    model: {
      value: (_vm.$store.state.CAR.selectedState),
      callback: function($$v) {
        _vm.$set(_vm.$store.state.CAR, "selectedState", $$v)
      },
      expression: "$store.state.CAR.selectedState"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Oops! No elements found. Change the search query.")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-2",
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('button', {
    staticClass: "material-button-raised pull-left",
    staticStyle: {
      "box-shadow": "0 0 5px gray",
      "color": "black",
      "border-radius": "0"
    },
    on: {
      "click": function($event) {
        _vm.showMore('compare')
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "11px",
      "font-family": "'Open Sans', sans-serif"
    }
  }, [_vm._v("Click to " + _vm._s(_vm.showCompareMsg))])])])]), _vm._v(" "), _c('div', {
    staticClass: "web-features",
    staticStyle: {
      "margin-top": "2px"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showComponents),
      expression: "showComponents"
    }],
    class: {
      'compare-dataset': _vm.compareSectionColorClass
    }
  }, [(_vm.getRelatedIndicators.length) ? _c('span', _vm._l((_vm.getRelatedIndicators), function(relatedIndicator, index) {
    return _c('CompareSec', {
      key: index,
      attrs: {
        "relatedIndicator": relatedIndicator
      }
    })
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "html2pdf__page-break"
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative",
      "top": "-60px"
    },
    attrs: {
      "id": "datasets"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "html2pdf__page-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "web-features row",
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "id": "bottom_of_page"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12",
    attrs: {
      "data-v-step": "9"
    }
  }, [_c('column-chart', {
    attrs: {
      "optionsIndicator": _vm.optionIndicators,
      "optionSources": _vm.optionSources,
      "appData": _vm.lsData,
      "meta_data": _vm.metaData,
      "dashboardStateOptions": _vm.dashboardStateOptionsArray,
      "contextSelectedIndicator": _vm.selectedIndicator
    },
    on: {
      "columnChartSource": _vm.changeDashboardState,
      "columnChartIndicator": _vm.changeDashboardState,
      "callerName": _vm.getCallerComponent
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row web-features"
  }), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.shareButtonClicked,
      "has-modal-card": ""
    },
    on: {
      "update:active": function($event) {
        _vm.shareButtonClicked = $event
      }
    }
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("SHARE PLATFORM")])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [(!_vm.loadingURLIcon && !_vm.errorFetchingURL) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-12 share-copybox"
  }, [_c('p', [_vm._v("\n                  COPY LINK:\n                  "), (_vm.linkCopied) ? _c('span', {
    staticStyle: {
      "color": "#3478b6"
    }
  }, [_vm._v("LINK COPIED")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "field row"
  }, [_c('div', {
    staticClass: "control has-icons-left col-xs-10"
  }, [_c('input', {
    staticClass: "input",
    attrs: {
      "id": "urlInput",
      "type": "text",
      "placeholder": "Share URL",
      "readonly": ""
    },
    domProps: {
      "value": _vm.shareURL
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon is-small is-left",
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('v-icon', [_vm._v("fas fa-link")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "share-clipboard-button col-xs-2"
  }, [_c('button', {
    attrs: {
      "title": "Copy to clipboard"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.copyURL($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("fas fa-clipboard")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-12 share-socialicons"
  }, [_c('p', [_vm._v("SHARE VIA")]), _vm._v(" "), _c('div', {
    staticClass: "share-icons col-sm-12 row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('i', {
    on: {
      "click": _vm.shareViaLinkedin
    }
  }, [_c('a', {
    staticClass: "fab fa-linkedin icon-linkedin vc_icon_element",
    attrs: {
      "color": "white"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('i', {
    attrs: {
      "id": "icon-email"
    },
    on: {
      "click": _vm.shareViaEmail
    }
  }, [_c('a', {
    staticClass: "fas fa-envelope icon-email vc_icon_element",
    attrs: {
      "color": "white"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('i', {
    attrs: {
      "id": "icon-twitter"
    },
    on: {
      "click": _vm.shareViaTwitter
    }
  }, [_c('a', {
    staticClass: "fab fa-twitter icon-twitter vc_icon_element",
    attrs: {
      "color": "white"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('i', {
    attrs: {
      "id": "icon-facebook"
    },
    on: {
      "click": _vm.shareViaFacebook
    }
  }, [_c('a', {
    staticClass: "fab fa-facebook-square icon-facebook vc_icon_element",
    attrs: {
      "color": "white"
    }
  })])])])])]) : (_vm.loadingURLIcon && !_vm.errorFetchingURL) ? _c('div', {
    staticStyle: {
      "width": "57px",
      "margin": "0 auto"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": 50,
      "width": 4,
      "color": "blue"
    }
  })], 1) : _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "red",
      "font-size": "18px"
    }
  }, [_c('b', [_vm._v("Something went wrong.")]), _c('br'), _vm._v("Please check your internet\n                connection and try again\n              ")])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('button', {
    staticClass: "button is-danger pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.shareButtonClicked = false
      }
    }
  }, [_vm._v("\n              CLOSE\n            ")])])])])])], 1), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isTourActive),
      expression: "!isTourActive"
    }, {
      name: "tooltip",
      rawName: "v-tooltip.left",
      value: ('Go to top of page'),
      expression: "'Go to top of page'",
      modifiers: {
        "left": true
      }
    }],
    staticClass: "material-button-raised goto-top-of-page",
    attrs: {
      "id": "scrollToTopButton"
    },
    on: {
      "click": function($event) {
        _vm.scrollup()
      }
    }
  }, [_c('v-icon', {
    staticClass: "mid-align",
    attrs: {
      "left": "",
      "dark": "",
      "large": "",
      "color": "white"
    }
  }, [_vm._v("keyboard_arrow_up")])], 1), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isTourActive),
      expression: "!isTourActive"
    }, {
      name: "tooltip",
      rawName: "v-tooltip.left",
      value: ('Go to bottom of page'),
      expression: "'Go to bottom of page'",
      modifiers: {
        "left": true
      }
    }],
    staticClass: "material-button-raised goto-top-of-page",
    attrs: {
      "id": "scrollToButtomButton"
    },
    on: {
      "click": function($event) {
        _vm.scrolldown()
      }
    }
  }, [_c('v-icon', {
    staticClass: "mid-align",
    attrs: {
      "left": "",
      "dark": "",
      "large": "",
      "color": "white"
    }
  }, [_vm._v("keyboard_arrow_down")])], 1), _vm._v(" "), _c('div', [_c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.firstTimeNotification),
      expression: "!firstTimeNotification"
    }]
  }, [_c('b-modal', {
    attrs: {
      "has-modal-card": "",
      "active": _vm.isTourActive
    },
    on: {
      "update:active": function($event) {
        _vm.isTourActive = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('div', {
    staticClass: "modal-card-head styleBody"
  }, [_c('span', {
    staticClass: "close-year-modal is-danger pull-right"
  }, [_c('i', {
    on: {
      "click": function($event) {
        _vm.isTourActive = false
      }
    }
  }, [_c('a', {
    staticClass: "fas fa-times-circle vc_icon_element_close",
    attrs: {
      "color": "#ff3860"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-card-body styleBody"
  }, [_c('div', {}, [_c('carousel', {
    attrs: {
      "items": 1,
      "margin": 10,
      "autoplay": false,
      "autoplayTimeout": 5000,
      "dots": true,
      "nav": true,
      "lazyLoad": true,
      "navText": _vm.owlNavText
    }
  }, [_c('div', [_c('section', [_c('div', {
    staticClass: "row nanleModal"
  }, [_c('p', [_c('img', {
    staticStyle: {
      "display": "block",
      "margin-left": "auto",
      "margin-right": "auto",
      "width": "45%",
      "height": "30%"
    },
    attrs: {
      "src": "static/img/tourIcons/Group441.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v("Welcome to")]), _vm._v(" "), _c('p', {
    staticClass: "my-0 pb-2",
    staticStyle: {
      "font-size": "1.4em"
    }
  }, [_c('strong', [_vm._v("The Multi-Source Data "), _c('br'), _vm._v("\n                            Analytics and Triangulation Platform\n                          ")])]), _vm._v(" "), _c('p', [_vm._v("\n                          The Multi-Source Data Analytics and Triangulation\n                          (MSDAT) Platform is owned by the Federal Ministry of\n                          Health and was developed to provide a single\n                          transparent view of key health indicators against\n                          multiple data sources - routine, non-routine and\n                          estimates.\n                        ")]), _vm._v(" "), _c('p', {
    staticClass: "pt-2 mb-0 pb-0"
  }, [_c('strong', [_vm._v("Watch tutorial video")])]), _vm._v(" "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "target": "_blank",
      "href": "https://www.youtube.com/watch?v=k75zoZ1SXgk"
    }
  }, [_c('strong', [_vm._v("youtube.com/watch?v=k75zoZ1SXgk")])]), _vm._v(" "), _c('p', {
    staticClass: "nanleHr"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "styleBody"
  }, [_c('section', [_c('div', {
    staticClass: "row nanleModal2"
  }, [_c('br'), _c('br'), _vm._v(" "), _c('h2', {
    staticClass: "text-left"
  }, [_vm._v("\n                          This platform contains four main sections:\n                        ")]), _vm._v(" "), _c('div', [_c('p', [_vm._v("i. Overview Section")]), _vm._v(" "), _c('p', [_vm._v("ii. Zonal Section")]), _vm._v(" "), _c('p', [_vm._v("\n                            iii. Multi-Source Indicator Comparison Section\n                          ")]), _vm._v(" "), _c('p', [_vm._v("iv. Multi-Dataset Comparison Section")]), _vm._v(" "), _c('p', [_c('img', {
    staticStyle: {
      "float": "right",
      "display": "block",
      "margin-left": "auto",
      "margin-right": "auto",
      "width": "35%",
      "height": "35%"
    },
    attrs: {
      "src": "static/img/tourIcons/Group-1.png"
    }
  })])])])])]), _vm._v(" "), _c('div', [_c('section', [_c('div', {
    staticClass: "row nanleModal"
  }, [_c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "nanleModalImage"
  }, [_c('img', {
    attrs: {
      "src": "static/img/tourIcons/main_section_.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "nanleModal"
  }, [_c('p', [_vm._v("Section 1:")]), _vm._v(" "), _c('h1', [_vm._v("Overview Section")])])])])]), _vm._v(" "), _c('div', [_c('section', [_c('div', {
    staticClass: "row nanleModal"
  }, [_c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "nanleModalImage"
  }, [_c('img', {
    attrs: {
      "src": "static/img/tourIcons/zonal_section.png"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {}, [_c('p', [_vm._v("Section 2:")]), _vm._v(" "), _c('h1', [_vm._v("Zonal Section")])])])])]), _vm._v(" "), _c('div', [_c('section', [_c('div', {
    staticClass: "row nanleModal"
  }, [_c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "nanleModalImage"
  }, [_c('img', {
    attrs: {
      "src": "static/img/tourIcons/multi_indicator_comparison.png"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {}, [_c('p', [_vm._v("Section 3:")]), _vm._v(" "), _c('h1', [_vm._v("Multi-Source Indicator Comparison Section")])])])])]), _vm._v(" "), _c('div', [_c('section', [_c('div', {
    staticClass: "row nanleModal"
  }, [_c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "nanleModalImage"
  }, [_c('img', {
    attrs: {
      "src": "static/img/tourIcons/multi_dataset.png"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {}, [_c('p', [_vm._v("Section 4:")]), _vm._v(" "), _c('h1', [_vm._v("Multi-Dataset Comparison Section")])])])])]), _vm._v(" "), _c('div', [_c('section', [_c('div', {
    staticClass: "row nanleModal"
  }, [_c('br'), _c('br'), _vm._v(" "), _c('div', [_c('img', {
    staticStyle: {
      "display": "block",
      "margin-left": "auto",
      "margin-right": "auto",
      "width": "35%",
      "height": "35%"
    },
    attrs: {
      "src": "static/img/tourIcons/Group472.png"
    }
  })]), _vm._v(" "), _c('div', {}, [_c('h2', [_vm._v("We value your feedback")]), _vm._v(" "), _c('p', [_vm._v("\n                            Click on the icon situated on the right side of\n                            the page to send us your feedback.\n                          ")])])])])]), _vm._v(" "), _c('div', [_c('section', [_c('div', {
    staticClass: "row nanleModal"
  }, [_c('br'), _c('br'), _vm._v(" "), _c('div', [_c('img', {
    staticStyle: {
      "display": "block",
      "margin-left": "auto",
      "margin-right": "auto",
      "width": "50%"
    },
    attrs: {
      "src": "static/img/tourIcons/msdat_tourguide_help.jpg"
    }
  })]), _vm._v(" "), _c('div', {}, [_c('p', [_vm._v("\n                            You can always play the tour guide "), _c('br'), _vm._v("\n                            from the menu bar and also visit the help page for\n                            more tips.\n                          ")]), _vm._v(" "), _c('h2', [_vm._v("Congratulations")]), _vm._v(" "), _c('p', [_vm._v("Have a wonderful experience")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.isTourActive = false
      }
    }
  }, [_vm._v("\n                            Skip Tour Guide\n                          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "background-color": "#007d53",
      "color": "white"
    },
    on: {
      "click": function($event) {
        (_vm.isTourStarts = true), (_vm.isTourActive = false)
      }
    }
  }, [_vm._v("\n                            Start Tour Guide\n                          ")])])])])])])], 1)])])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "has-modal-card": "",
      "active": _vm.isTourStarts
    },
    on: {
      "update:active": function($event) {
        _vm.isTourStarts = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('div', {
    staticClass: "modal-card-body modal-sm",
    staticStyle: {
      "width": "50%",
      "margin-left": "26%"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-8 col-md-8"
  }, [_c('h1', {
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v("Welcome!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("\n                  For a quick tour of the MSDAT platform key functions,\n                  "), _c('b', [_vm._v("click Next")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.startTour()
      }
    }
  }, [_vm._v("Next >")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-md-4"
  }, [_c('img', {
    attrs: {
      "src": "static/img/tour/group_410.png"
    }
  })])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "has-modal-card": "",
      "active": _vm.contactForm,
      "id": "contactForm"
    },
    on: {
      "update:active": function($event) {
        _vm.contactForm = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-card",
    on: {
      "click": function($event) {
        _vm.stopTimer()
      }
    }
  }, [_c('div', {
    staticClass: "modal-card-body",
    staticStyle: {
      "max-width": "450.75px",
      "margin": "auto",
      "padding-top": "15px",
      "border-radius": "7px"
    }
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', [_c('button', {
    staticClass: "pull-right",
    staticStyle: {
      "display": "block"
    },
    on: {
      "click": function($event) {
        _vm.contactForm = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('h6', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Nice to Meet You!")])])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('p', {
    staticStyle: {
      "font-weight": "400",
      "font-size": "12px",
      "padding-bottom": "15px"
    },
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n                  Welcome to the Multi-Source Data Analytics and\n                  Triangulation"), _c('br'), _vm._v("(MSDAT) Platform. Would you like to\n                  "), _c('b', [_vm._v("stay informed about the platform by receiving the latest\n                    updates?")])])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12 col-sm-12"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.conformSend()
      }
    }
  }, [_c('div', [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "100",
      "font-size": "13px"
    }
  }, [_vm._v("\n                          Leave us a few details to make that happen.\n                        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nofields),
      expression: "nofields"
    }],
    staticClass: "alert alert-warning"
  }, [_vm._v("\n                          The following fields are required: Name, Email\n                          Address and Profession\n                        ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.successmessage),
      expression: "successmessage"
    }],
    staticClass: "alert alert-success"
  }, [_vm._v("\n                          Thank you. We will keep you informed about the\n                          latest updates to the MSDAT Platform.\n                        ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errormessage),
      expression: "errormessage"
    }],
    staticClass: "alert alert-danger"
  }, [_vm._v("\n                          An error occured, please try again later.\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactFormFields.name),
      expression: "contactFormFields.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Name *",
      "required": "",
      "minlength": "4"
    },
    domProps: {
      "value": (_vm.contactFormFields.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contactFormFields, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactFormFields.email),
      expression: "contactFormFields.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Email address *",
      "required": "",
      "email": ""
    },
    domProps: {
      "value": (_vm.contactFormFields.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contactFormFields, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactFormFields.profession),
      expression: "contactFormFields.profession"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Profession or Field or Work/Study *",
      "required": ""
    },
    domProps: {
      "value": (_vm.contactFormFields.profession)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contactFormFields, "profession", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactFormFields.organization),
      expression: "contactFormFields.organization"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Organization"
    },
    domProps: {
      "value": (_vm.contactFormFields.organization)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contactFormFields, "organization", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "padding-bottom": "13px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "400",
      "font-size": "12px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactFormFields.newsletter),
      expression: "contactFormFields.newsletter"
    }],
    attrs: {
      "type": "checkbox",
      "true-value": "true",
      "false-value": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.contactFormFields.newsletter) ? _vm._i(_vm.contactFormFields.newsletter, null) > -1 : _vm._q(_vm.contactFormFields.newsletter, "true")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.contactFormFields.newsletter,
          $$el = $event.target,
          $$c = $$el.checked ? ("true") : ("false");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.contactFormFields, "newsletter", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.contactFormFields, "newsletter", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.contactFormFields, "newsletter", $$c)
        }
      }
    }
  }), _vm._v("\n                            I would also like to help improve the platform by\n                            giving my opinion and suggestions from time to\n                            time.\n                          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loader),
      expression: "loader"
    }],
    staticClass: "animated preFadeInUp fadeInUp",
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100px"
    },
    attrs: {
      "src": "static/img/ajax-loader.gif"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "background-color": "#007d53",
      "color": "white",
      "box-shadow": "0px 7px 15px rgba(0, 0, 0, 0.4)",
      "border-color": "#007d53",
      "width": "127.5px",
      "height": "41px",
      "margin-bottom": "15px"
    }
  }, [_vm._v("\n                            Submit\n                          ")]), _vm._v(" "), _c('p', [_c('a', {
    staticStyle: {
      "color": "#707070",
      "font-weight": "300",
      "font-size": "15px",
      "padding-top": "15px"
    },
    on: {
      "click": function($event) {
        _vm.contactForm = false
      }
    }
  }, [_vm._v("Maybe next time")])])])])])])])])])])])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-520a7422","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboards/car/mainCar/MainCarDashboard.vue
// module id = 966
// module chunks = 0